<template>
	<div id="page-customer" class="customer-info">
		<vx-card title="顧客詳細" card-background="rgb(240, 238, 241)" height="420px" class="pb-2" style="font-size: 12px">
			<vs-row>
				<vs-col vs-w="6">
					<vs-row>
						<vs-col class="flex items-center" vs-w="3">
							<span class="pt-2">ID</span>
						</vs-col>
						<vs-col vs-w="3">
							<vs-input disabled class="w-full mb-2" :value="value.id" />
						</vs-col>
					</vs-row>
					<!-- customer type -->
					<vs-row>
						<vs-col class="flex items-center" vs-w="3">
							<span>お客様種別</span>
						</vs-col>
						<vs-col vs-w="9">
							<vs-row>
								<div class="mr-4 my-3" v-for="type in customerType" :key="type.key">
									<input
										type="radio"
										v-model="value.customer_type_flg"
										@input="update('customer_type_flg', $event.target.value)"
										:value="type.key"
										name="customer_type"
										class="mr-1"
										style="position: relative; top: 2px"
									/>
									<span>{{ type.value }}</span>
								</div>
							</vs-row>
						</vs-col>
					</vs-row>
					<!-- next -->
					<vs-row>
						<vs-col class="flex items-center" vs-w="3">
							<span>名前<span style="color: red">*</span></span>
						</vs-col>
						<vs-col vs-w="4">
							<vs-input
								v-validate.immediate="'required'"
								maxlength="64"
								data-vv-as="姓"
								name="last_name"
								@input="update('last_name', $event)"
								v-model="value.last_name"
								class="w-full mb-2"
								placeholder="姓(漢字)"
							/>
						</vs-col>
						<vs-col vs-w="1"></vs-col>
						<vs-col vs-w="4">
							<vs-input
								v-validate.immediate="'required'"
								maxlength="64"
								data-vv-as="名"
								name="first_name"
								@input="update('first_name', $event)"
								v-model="value.first_name"
								class="w-full mb-2"
								placeholder="名(漢字)"
							/>
						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col vs-offset="3" vs-w="4">
							<span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block">{{
								errors.first('last_name') | convertError
							}}</span>
						</vs-col>
						<vs-col vs-w="1"></vs-col>
						<vs-col vs-w="4">
							<span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block">{{
								errors.first('first_name') | convertError
							}}</span>
						</vs-col>
					</vs-row>
					<!-- next -->

					<vs-row>
						<vs-col class="flex items-center" vs-w="3">
							<span>よみがな</span>
						</vs-col>
						<vs-col vs-w="4">
							<vs-input
								maxlength="64"
								@input="update('last_name_kana', $event)"
								v-model="value.last_name_kana"
								class="w-full mb-2"
								placeholder="姓(ひらがな)"
							/>
						</vs-col>
						<vs-col vs-w="1"></vs-col>
						<vs-col vs-w="4">
							<vs-input
								maxlength="64"
								@input="update('first_name_kana', $event)"
								v-model="value.first_name_kana"
								class="w-full mb-2"
								placeholder="名(ひらがな)"
							/>
						</vs-col>
					</vs-row>

					<!-- next -->
					<vs-row>
						<vs-col class="flex items-center" vs-w="3">
							<span>性別</span>
						</vs-col>
						<vs-col vs-w="9">
							<vs-row>
								<div class="mr-4 my-3" v-for="type in genderType" :key="`gender-key-${type.key}`">
									<input
										type="radio"
										@input="update('gender', $event.target.value)"
										v-model="value.gender"
										:value="type.key"
										name="gender_type"
										class="mr-1"
										style="position: relative; top: 2px"
									/>
									<span>{{ type.value }}</span>
								</div>
							</vs-row>
						</vs-col>
					</vs-row>
					<!-- next -->
					<vs-row>
						<vs-col class="flex items-center" vs-w="3">
							<span>メールアドレス<span style="color: red">*</span></span>
						</vs-col>
						<vs-col vs-w="4">
							<vs-input
								@input="update('email1', $event)"
								v-model="value.email1"
								v-validate.immediate="'required|email|override-email'"
								data-vv-as="メールアドレス"
								maxlength="256"
								name="email1"
								placeholder="メールアドレスを入力"
								class="w-full mb-2"
							/>
						</vs-col>
						<vs-col vs-w="1"></vs-col>
						<vs-col vs-w="4">
							<vs-input
								@input="update('email2', $event)"
								v-model="value.email2"
								v-validate.immediate="'email|override-email'"
								data-vv-as="メールアドレス"
								name="email2"
								maxlength="256"
								placeholder="メールアドレスを入力"
								class="w-full mb-2"
							/>
						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col vs-offset="3">
							<span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block">{{
								errors.first('email1') | convertError
							}}</span>
							<span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block">{{
								errors.first('email2') | convertError
							}}</span>
						</vs-col>
					</vs-row>
				</vs-col>
				<vs-col vs-w="6">
					<div class="ml-16">
						<vs-row>
							<vs-col class="flex items-center" vs-w="3">
								<span>会社名</span>
							</vs-col>
							<vs-col vs-w="9">
								<vs-row>
									<vs-input
										@input="update('company_name', $event)"
										v-model="value.company_name"
										name="会社名"
										maxlength="128"
										class="w-full mb-2"
										placeholder="株式会社〇〇"
									/>
								</vs-row>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col vs-offset="3">
								<span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block">{{
									errors.first('会社名') | convertError
								}}</span>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col class="flex items-center" vs-w="3">
								<span>よみがな</span>
							</vs-col>
							<vs-col vs-w="9">
								<vs-row>
									<vs-input
										@input="update('company_name_kana', $event)"
										v-model="value.company_name_kana"
										maxlength="64"
										class="w-full mb-2"
										placeholder="かぶしきかいしゃ〇〇"
									/>
								</vs-row>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col class="flex items-center" vs-w="3">
								<span>業種名</span>
							</vs-col>
							<vs-col vs-w="3">
								<vs-input
									@input="update('industry_name', $event)"
									v-model="value.industry_name"
									maxlength="256"
									name="業種名"
									class="w-full mb-2 mr-2"
									placeholder="業種名を入力"
							/></vs-col>
							<vs-col class="flex items-center text-center" vs-w="3">
								<span class="w-full text-center">部署名</span>
							</vs-col>
							<vs-col vs-w="3">
								<vs-row>
									<vs-input
										@input="update('department_name', $event)"
										v-model="value.department_name"
										maxlength="64"
										class="w-full mb-2"
										placeholder="部署名を入力"
									/>
								</vs-row>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col vs-offset="3">
								<span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block">{{
									errors.first('業種名') | convertError
								}}</span>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col class="flex items-center" vs-w="3">
								<span>郵便番号</span>
							</vs-col>
							<vs-col vs-w="9">
								<vs-row>
									<vs-input
										@input="update('postal_code', $event)"
										v-model="value.postal_code"
										name="郵便番号"
										maxlength="64"
										class="w-full mb-2"
										placeholder="例：0001234 (半角･ハイフンなし)"
									/>
								</vs-row>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col vs-offset="3">
								<span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block">{{
									errors.first('郵便番号') | convertError
								}}</span>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col class="flex items-center" vs-w="3">
								<span>都道府県</span>
							</vs-col>
							<vs-col vs-w="9">
								<v-select
									class="sl-prefecture w-full mb-2 bg-white"
									placeholder="選択してください"
									label="value"
									:searchable="false"
									:reduce="(item) => item.key"
									:options="prefectureOptions"
									@input="update('prefecture_name', $event)"
									v-model="value.prefecture_name"
								>
								</v-select>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col class="flex items-center" vs-w="3">
								<span>住所</span>
							</vs-col>
							<vs-col vs-w="9">
								<vs-row>
									<vs-input
										@input="update('address', $event)"
										v-model="value.address"
										maxlength="256"
										class="w-full mb-2"
										placeholder="例：〇〇市△△区〇〇町0-0"
									/>
								</vs-row>
							</vs-col>
						</vs-row>
					</div>
				</vs-col>
			</vs-row>
			<vs-row v-show="isShowDetail" class="animate-open-div">
				<vs-col vs-w="6">
					<!-- right -->
					<vs-row>
						<vs-col class="flex items-center" vs-w="3">
							<span>購入先</span>
						</vs-col>
						<vs-col vs-w="9">
							<vs-row>
								<vs-input
									@input="update('retailer_name', $event)"
									v-model="value.retailer_name"
									maxlength="64"
									class="w-full mb-2"
									placeholder="購入先を入力"
								/>
							</vs-row>
						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col class="flex items-center" style="align-self: baseline" vs-w="3">
							<span>備考</span>
						</vs-col>
						<vs-col vs-w="9" class="remark-textarea">
							<vs-textarea
								@input="update('remarks', $event)"
								v-model="value.remarks"
								maxlength="256"
								class="w-full mb-2"
								placeholder="備考を入力"
							/>
						</vs-col>
					</vs-row>
				</vs-col>
				<vs-col vs-w="6">
					<div class="ml-16">
						<vs-row>
							<vs-col class="flex items-center" vs-w="3">
								<span>電話番号</span>
							</vs-col>
							<vs-col vs-w="4">
								<vs-row>
									<vs-input
										v-validate.immediate="'numeric'"
										name="電話番号"
										@input="update('phone_number1', $event)"
										v-model="value.phone_number1"
										maxlength="15"
										placeholder="(半角･ハイフンなし)"
										class="w-full mb-2"
									/>
								</vs-row>
							</vs-col>
							<vs-col vs-w="1"></vs-col>
							<vs-col vs-w="4">
								<vs-row>
									<vs-input
										v-validate.immediate="'numeric'"
										name="電話番号"
										@input="update('phone_number2', $event)"
										v-model="value.phone_number2"
										maxlength="15"
										placeholder="(半角･ハイフンなし)"
										class="w-full mb-2"
									/>
								</vs-row>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col vs-offset="3">
								<span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block">{{
									errors.first('電話番号') | convertError
								}}</span>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col class="flex items-center" vs-w="3">
								<span>FAX</span>
							</vs-col>
							<vs-col vs-w="9">
								<vs-row>
									<vs-input
										v-validate.immediate="'numeric'"
										name="FAX"
										@input="update('fax_number', $event)"
										v-model="value.fax_number"
										maxlength="15"
										placeholder="例：0312345678 (半角･ハイフンなし)"
										class="w-full mb-2"
									/>
								</vs-row>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col vs-offset="3">
								<span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block">{{
									errors.first('FAX') | convertError
								}}</span>
							</vs-col>
						</vs-row>

						<vs-row>
							<vs-col class="flex items-center" vs-w="3">
								<span>メールドメイン</span>
							</vs-col>
							<vs-col vs-w="9">
								<vs-row>
									<vs-input
										name="メールドメイン"
										v-validate.immediate="'mail-domain'"
										@input="update('mail_domain', $event)"
										v-model="value.mail_domain"
										maxlength="64"
										placeholder="メールドメイン"
										class="w-full mb-2"
									/>
								</vs-row>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col vs-offset="3">
								<span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block">{{
									errors.first('メールドメイン') | convertError
								}}</span>
							</vs-col>
						</vs-row>
					</div>
				</vs-col>
			</vs-row>
			<div class="flex items-center justify-center gap-10 my-4 text-lg cursor-pointer" @click="isShowDetail = !isShowDetail">
				<p class="material-icons text-primary text-3xl" :class="{ 'transform rotate-180': isShowDetail }">arrow_drop_down_circle</p>
				詳細情報を表示
			</div>
			<vs-divider></vs-divider>
			<div class="flex justify-center">
				<vs-button :disabled="!validateForm && submited" @click="onCreateOrUpdateCustomer">新規作成</vs-button>
				<vs-button @click="clearCustomer" color="warning">入力クリア</vs-button>
			</div>
		</vx-card>
	</div>
</template>

<script>
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import { mapActions } from 'vuex'

// Cell Renderer
import { CUSTOMER_TYPE, GENDER_TYPE } from '@/enums/customer'

export default {
	props: {
		value: {
			type: Object,
			default: () => ({ ...this.initialCustomer })
		},
		validCustomerInfo: Boolean,
		submited: Boolean
	},
	components: {
		vSelect
	},
	data() {
		return {
			isShowDetail: false,
			title: '',
			id: null,
			ids: [],
			deleteId: null,
			//To Import CSV File
			activeUpload: false,
			fileName: '',
			file: null,
			fileUploadCheck: false,
			validFile: false,
			fileImportError: {
				message: '',
				flag: false
			},
			// Filter Options
			filterCustomers: {
				id: null,
				name: null,
				email: null,
				phone_number: null,
				customer_type: null,
				company_name: null,
				industry_name: null,
				address: null
			},
			customerType: [
				{ key: CUSTOMER_TYPE.INDIVIDUAL.value, value: CUSTOMER_TYPE.INDIVIDUAL.name },
				{ key: CUSTOMER_TYPE.CORPORATE.value, value: CUSTOMER_TYPE.CORPORATE.name },
				{ key: CUSTOMER_TYPE.DEALER.value, value: CUSTOMER_TYPE.DEALER.name },
				{ key: CUSTOMER_TYPE.BRANCH.value, value: CUSTOMER_TYPE.BRANCH.name },
				{ key: CUSTOMER_TYPE.OTHER.value, value: CUSTOMER_TYPE.OTHER.name }
			],
			customerTypeFilter: [{ key: null, value: '...' }],
			genderType: [
				{ key: GENDER_TYPE.MEN.value, value: GENDER_TYPE.MEN.name },
				{ key: GENDER_TYPE.WOMEN.value, value: GENDER_TYPE.WOMEN.name },
				{ key: GENDER_TYPE.OTHER.value, value: GENDER_TYPE.OTHER.name }
			],
			paginationOptions: [10, 100, 500, 1000],

			//SortServer
			orderBy: 'id',
			orderDir: 'desc',

			//Pagination
			paginationPageSize: 10,
			pageNumber: 1,
			startRow: 0,
			endRow: 0,

			subscriptionsForCustomer: [],
			dataExport: [],
			labelExport: {},
			addFlg: false,
			initialCustomer: {
				id: null,
				last_name: '',
				first_name: '',
				last_name_kana: '',
				first_name_kana: '',
				email1: '',
				email2: '',
				phone_number1: '',
				phone_number2: '',
				customer_type_flg: 0,
				company_name: '',
				company_name_kana: '',
				gender: 0,
				industry_name: '',
				department_name: '',
				postal_name: '',
				prefecture_name: '',
				address: '',
				fax_number: '',
				mail_domain: '',
				retailer_name: '',
				remarks: ''
			},
			prefectureOptions: [
				{ key: 0, value: '北海道' },
				{ key: 1, value: '青森県' },
				{ key: 2, value: '岩手県' },
				{ key: 3, value: '宮城県' },
				{ key: 4, value: '秋田県' },
				{ key: 5, value: '山形県' },
				{ key: 6, value: '福島県' },
				{ key: 7, value: '茨城県' },
				{ key: 8, value: '栃木県' },
				{ key: 9, value: '群馬県' },
				{ key: 10, value: '埼玉県' },
				{ key: 11, value: '千葉県' },
				{ key: 12, value: '東京都' },
				{ key: 13, value: '神奈川県' },
				{ key: 14, value: '新潟県' },
				{ key: 15, value: '富山県' },
				{ key: 16, value: '石川県' },
				{ key: 17, value: '福井県' },
				{ key: 18, value: '山梨県' },
				{ key: 19, value: '長野県' }
			]
		}
	},
	computed: {
		validateForm() {
			return !this.errors.any()
		}
	},
	watch: {
		validateForm(val) {
			this.$emit('changeValidCustomerInfo', val)
		}
	},
	methods: {
		...mapActions({
			createOrUpdateCustomer: 'receiveTelephone/createOrUpdateCustomer'
		}),
		async onCreateOrUpdateCustomer() {
			this.$emit('update:submited', true)
			if (this.validateForm) {
				const customerId = await this.createOrUpdateCustomer(this.value)
				this.update('id', customerId)
			}
		},
		update(key, value) {
			this.$emit('input', { ...this.value, [key]: value })
		},
		clearCustomer(){
			this.$emit('clearCustomer')
		}
	}
}
</script>
<style lang="scss">
@import '@/assets/scss/vuexy/components/view/customer.scss';
:root {
	/* Dropdown */
	--vs-dropdown-max-height: 205px !important;
}
</style>
